import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class DashboardService {

    getEventRoute = '/api/newevents/';

    constructor(private dataService: DataService) {
    };

     getDashboard(data,refresh: boolean) {
        return this.dataService.getData('/api/dashboard/dashboardbarchart/' + data.districtId + '/' + data.blockId , refresh);
    }

    getDashBoardData(data: any, refresh: boolean) {
        return this.dataService.getData('/api/dashboard/dashboardchart/' + data.districtId + '/' + data.blockId, refresh);
    }

}
